import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class DelegationService {

  constructor(private http: HttpClient) { }

  getAllDelegations(rowsNumber: number, pageNo, sorting: any, searchValue: string, filterValues: any, request_number: number,dateFrom,dateTo){
    let filterValuesForRolesApi = '';
    let filterValuesForStatusApi = '';
    let filterFromDate='';
    let filterToDate='';
    if (filterValues.roles !== undefined) {
      filterValues.roles.map((filterValue: string) => {
        filterValuesForRolesApi = filterValuesForRolesApi.concat('&created_by_role_name[]=' + filterValue)
      })
  }
  if (filterValues.status !== undefined) {
      filterValues.status.map((filterValue: string) => {
        filterValuesForStatusApi = filterValuesForStatusApi.concat('&status[]=' + filterValue)
      })
  }
  if(dateFrom !== undefined){
    filterFromDate = filterFromDate.concat('&from_date=' + dateFrom)
  }
  if(dateTo !== undefined){
    filterToDate = filterToDate.concat('&to_date=' + dateTo)
  }
    return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/delegation?per_page=${rowsNumber}&page=${pageNo}
    ${searchValue === undefined || searchValue === '' ? '' : '&search=' + searchValue}
    ${filterValuesForRolesApi}
    ${filterValuesForStatusApi} 
    ${filterFromDate}
    ${filterToDate}
    `)
  }
  getDelegationById(delegationId){
    return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/delegation/${delegationId}`)
  }
  deleteDelaegationById(delegationId){
    return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/delegation/${delegationId}`)
  }
  createDelegation(body) {
    return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/delegation`,body)
}
getUseresByRole(role){
  return this.http.get(environment.url + `schools/${localStorage.getItem('schoolId')}/users/role/${role}`)

}
updateDelegationRequest(delegationId , body){
  return this.http.put(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/delegation/${delegationId}`, body)

}
deleteDelegationRequets(body){
  return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/delegation/delete/bulk`, body)
}
}
